import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "top-bar theme-bg-primary-darken" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "navbar navbar-expand-lg navbar-dark position-relative" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_5 = { class: "navbar-nav me-lg-auto" }
const _hoisted_6 = { class: "nav-item ms-lg-1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_8 = { class: "navbar-nav ms-lg-auto" }
const _hoisted_9 = { class: "nav-item me-lg-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Projects")
const _hoisted_11 = { class: "nav-item me-lg-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Talks")
const _hoisted_13 = { class: "nav-item me-lg-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Blog")
const _hoisted_15 = { class: "nav-item me-0" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { id: "slide-line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("nav", _hoisted_3, [
        _createVNode("button", {
          class: "navbar-toggler",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navigation",
          "aria-controls": "navigation",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
        }, [
          _hoisted_4
        ]),
        _createVNode("div", {
          id: "navigation",
          class: ["navbar-collapse text-uppercase", { collapse: _ctx.menuCollapsed }]
        }, [
          _createVNode("ul", _hoisted_5, [
            _createVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: { name: 'home' },
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeMenu()))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("ul", _hoisted_8, [
            _createVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: { name: 'projects' },
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeMenu()))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: { name: 'talks' },
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeMenu()))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: { name: 'blog' },
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeMenu()))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _createVNode("li", _hoisted_15, [
              _createVNode("a", {
                class: "nav-link",
                href: "#hire-me",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeMenu()))
              }, "Contact")
            ])
          ]),
          _hoisted_16
        ], 2)
      ])
    ])
  ]))
}